import React from 'react';
import { IconProps } from './types';

const CancelIcon: React.FC<IconProps> = props => {
  const { className, size = 16, onClick } = props;
  return (
    <svg
      className={className}
      onClick={onClick}
      width={size}
      height={size}
      viewBox={`"0 0 ${size} ${size}"`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_13167_117456" maskUnits="userSpaceOnUse" x="0" y="0" width={size} height="16">
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13167_117456)">
        <path
          d="M7.99954 8.93385L4.73288 12.2005C4.61066 12.3227 4.4551 12.3839 4.26621 12.3839C4.07732 12.3839 3.92177 12.3227 3.79954 12.2005C3.67732 12.0783 3.61621 11.9227 3.61621 11.7339C3.61621 11.545 3.67732 11.3894 3.79954 11.2672L7.06621 8.00052L3.79954 4.73385C3.67732 4.61163 3.61621 4.45608 3.61621 4.26719C3.61621 4.0783 3.67732 3.92274 3.79954 3.80052C3.92177 3.6783 4.07732 3.61719 4.26621 3.61719C4.4551 3.61719 4.61066 3.6783 4.73288 3.80052L7.99954 7.06719L11.2662 3.80052C11.3884 3.6783 11.544 3.61719 11.7329 3.61719C11.9218 3.61719 12.0773 3.6783 12.1995 3.80052C12.3218 3.92274 12.3829 4.0783 12.3829 4.26719C12.3829 4.45608 12.3218 4.61163 12.1995 4.73385L8.93288 8.00052L12.1995 11.2672C12.3218 11.3894 12.3829 11.545 12.3829 11.7339C12.3829 11.9227 12.3218 12.0783 12.1995 12.2005C12.0773 12.3227 11.9218 12.3839 11.7329 12.3839C11.544 12.3839 11.3884 12.3227 11.2662 12.2005L7.99954 8.93385Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};

export default CancelIcon;
